import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatTableDataSource } from '@angular/material/table';
import { AlertifyService } from 'src/app/services/alertify.service';
import { EmpresaService } from 'src/app/services/empresa.service';
import { PlanService } from 'src/app/services/plan.service';
import { CreateEditPlanComponent } from './create-edit-plan/create-edit-plan.component';

@Component({
  selector: 'app-index-planes-admin',
  templateUrl: './index-planes-admin.component.html',
  styleUrls: ['./index-planes-admin.component.scss'],
})
export class IndexPlanesAdminComponent implements OnInit {
  public dataSource: any;
  displayedColumns: string[];
  public lstClubes: any;
  public clubSelect: any;

  constructor(
    public empresaSvc: EmpresaService,
    public planSvc: PlanService,
    public dialog: MatDialog,
    private alertify: AlertifyService
  ) {
    let ELEMENT_DATA: any[] = [];
    this.displayedColumns = [
      'nombre',
      'descripcion',
      'mesesDeVigencia',
      'valor',
      'estado',
      'botones'
    ];

    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
  }
  ngAfterViewInit() {
    // this.dataSource.paginator = this.paginator;
    this.empresaSvc.getEmpresasDropdown().subscribe((clubLst) => {
      console.log(clubLst);
      this.lstClubes = clubLst;
    });
    // this.getPlanes();
  }

  ngOnInit(): void {}

  cambioClubBuscar() {
    this.getPlanes();
  }

  getPlanes() {
    // this.isLoadingResults = true;
    this.planSvc.GetPlanes(this.clubSelect).subscribe((result) => {
      this.dataSource = new MatTableDataSource<any>(result);

      console.log('resultado: ', result);
    });
  }

  onToggle(ob: MatSlideToggleChange, elemento: any) {
    console.log(ob.checked);
    console.log(elemento);

    if (ob.checked) {
      this.planSvc
        .AsignarPlanAEmpresa(elemento.planId, elemento.empresaId)
        .subscribe((result) => {
          if (result) {
            elemento.asignado = ob.checked;
          } else {
            console.log('error al cambiar de estado');
          }
        });
    } else {
      this.planSvc
        .EliminarPlanAEmpresa(elemento.planId, elemento.empresaId)
        .subscribe((result) => {
          if (result) {
            elemento.asignado = ob.checked;
          } else {
            console.log('error al cambiar de estado');
          }
        });
    }
  }

  openDialogCreate(): void {
    let dialogRef = this.dialog.open(CreateEditPlanComponent, {
      data: null,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result == 'false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por creacion');
        this.getPlanes();
      }
    });
  }

  edit(obj: any) {
    console.log(obj);

    let dialogRef = this.dialog.open(CreateEditPlanComponent, {
      data: obj,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('dialogo cerrado: ');
      console.log(result);
      console.log(result == 'false');
      if (result == 'false') {
        console.log('dialogo cerrado - no actualiza');
      } else {
        console.log('dialogo cerrado - SI actualiza por edicion');
        this.getPlanes();
      }
    });
  }
}
